import React from 'react';
import PropTypes from 'prop-types';
import {
  VolumeButton,
} from './styles';

export default function LowSoundIcon({ onClick }) {
  return (
    <VolumeButton
      viewBox="0 -3 30 28"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M0 7.60309V14.2231C0 15.1333 0.775 15.8781 1.72222 15.8781H6.88889L12.555 21.3231C13.64
          22.3657 15.5 21.621 15.5 20.148V1.66164C15.5 0.188689 13.64 -0.556061 12.555 0.48659L6.88889
          5.94809H1.72222C0.775 5.94809 0 6.69284 0 7.60309ZM23.25 10.9131C23.25 7.98374 21.4933 5.46814
          18.9444 4.24344V17.5662C21.4933 16.358 23.25 13.8424 23.25 10.9131Z"
          fill="white"
        />
      </g>
    </VolumeButton>
  );
}

LowSoundIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
};
